"use client";

import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import { AgentPageData } from "./page";
import { AgentView } from "../../../../../../../searchAndCollection/components/agents/AgentView";
import { DefaultPageLayout } from "../../../../../../../components/layout/DefaultPageLayout";

const AgentClientSide = ({ agent, initialAgentWorksData, subjectsFromFacet, externalData }: AgentPageData) => {
  return (
    <DefaultPageLayout>
      <DefaultContainer>
        <AgentView
          agent={agent}
          externalData={externalData}
          initialAgentWorksData={initialAgentWorksData}
          subjectsFromfacet={subjectsFromFacet}
        />
      </DefaultContainer>
    </DefaultPageLayout>
  );
};

export default AgentClientSide;
